'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockReason = void 0;
var BlockReason;
(function (BlockReason) {
    BlockReason["PANIC_SELF_EXCLUSION"] = "PanicSelfExclusion";
    BlockReason["PANIC_TIMEOUT"] = "PanicTimeout";
})(BlockReason = exports.BlockReason || (exports.BlockReason = {}));
